import i18n from '@/plugins/i18n'

export default [
    {
        path: '/' + i18n.t('modules.routes.index'),
        name: 'modules.index',
        component: () =>
            import(
                /* webpackChunkName: "modules" */ '@/views/modules/Index.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('modules.breadcrumbs.index'),
                    to: { name: 'modules.index' },
                    disable: true,
                },
            ],
        },
    },
    {
        path: '/' + i18n.t('modules.routes.edit') + '/:id',
        name: 'modules.edit',
        component: () =>
            import(
                /* webpackChunkName: "modules" */ '@/views/modules/Edit.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('modules.breadcrumbs.index'),
                    to: { name: i18n.t('modules.routes.index') },
                    disable: false,
                },
                {
                    text: i18n.t('form.actions.edit'),
                    to: { name: 'modules.edit' },
                    disable: true,
                },
            ],
        },
        props: true,
    },
]
